import {toNumber} from "lodash";
import {DISTRICTS_LIST, PREVIEW_DOC_TYPES} from "./Constants";

const removeThousandSeparators = (val: string): string => {
    return val.replace(/,/g, '');
};

const removeCommaSeparators = (value: number) => {
    return toNumber((value.toString()).replace(/,/g, ''))
}
const checkThousandSeparated = (val: string): boolean => {
    const separatorRegex = /,/;

    return separatorRegex.test(val);
};

const currencyFormat = (value: number | undefined) => {

    if (value) {
        let stringValue = value.toString()
        return addDecimalPlaces(stringValue).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
    return "0.00"
}


const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

    if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
        return PREVIEW_DOC_TYPES.IMAGE;
    } else {
        return PREVIEW_DOC_TYPES.PDF;
    }

};


const addDecimalPlaces = (value: string): string => {
    const decimalIndex = value.indexOf('.');
    if (decimalIndex === -1) {
        return value + '.00';
    } else {
        const decimalPart = value.substring(decimalIndex + 1);
        if (decimalPart.length === 1) {
            return value + '0';
        } else if (decimalPart.length > 2) {
            return value.substring(0, decimalIndex + 3);
        }
    }
    return value;
}

const toFixedMethod = (name: string, value: any, form: any) => {
    if (value) {
        let val = !CommonFunction.checkThousandSeparated(value) ? value.toString() : CommonFunction.removeThousandSeparators(value);
        let jsonData: any = {};
        if (val.includes(".")) {
            const dotIndex = val.indexOf(".");
            if (dotIndex === val.length - 1 || val[dotIndex + 1] === "") {
                val = val.slice(0, dotIndex);
            } else {
                val = val.slice(0, dotIndex + 3);
            }
        }
        jsonData[name] = CommonFunction.currencyFormat(val);
        form.setFieldsValue(jsonData);
    }
};
const validateText = (value: string | number | undefined) => {
    return undefined == value || "" == value ? "N/A" : value;
}

const download = (val: string, docName: string) => {
    let a = document.createElement('a');
    a.href = val;
    a.download = docName;
    a.click();
}
const decimalFormat = (value: string | number |undefined): any => {
    if (undefined != value && null != value) {
        let val = value.toString();
        if (val.indexOf(".") != -1) {
            val = val.slice(0, (val.indexOf(".")) + 3);
        }
        val = (+val).toFixed(2);
        return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "0.00";
}
const addThousandSeparators = (value: string | number | undefined): any => {
    if (undefined != value && null != value) {
        let val = value.toString();
        return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "0";
}

const formatDate = (inputDate: string): string => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString('default', {month: 'short'});
    const year = date.getFullYear();
    const daySuffix = getDaySuffix(day);

    return `${day}${daySuffix} ${month} ${year}`;
}

const getDistrictLabelFromValue = (value: string): string | undefined => {
    const district = DISTRICTS_LIST.find(item => item.value === value);
    return district ? district.label : value;
};


function getDaySuffix(day: number): string {
    if (day >= 11 && day <= 13) {
        return 'th';
    }
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}

const CommonFunction = {
    removeThousandSeparators,
    removeCommaSeparators,
    addThousandSeparators,
    checkThousandSeparated,
    currencyFormat,
    validateText,
    download,
    toFixedMethod,
    decimalFormat,
    addDecimalPlaces,
    formatDate,
    getDistrictLabelFromValue,
    checkDocumentContentType
};


export default CommonFunction;